// Espelha TipoDocumentoItemCompraEnum do OrquestradorCompras: o documento de onde vem um item comprado do
// fornecedor (aba Produtos das últimas compras).
export enum TipoDocumentoItemCompraEnum {
  OrdemDeCompra = 1,
  NotaDeEntrada = 2,
}
